import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { App } from './app/app';
import { reportBootFailure } from './app/boot-failure';

bootstrapApplication(App, appConfig).catch((err) => {
  console.error(err);
  // The boot shell in index.html is removed by the root component once the
  // first page renders. If we got here, the root never rendered and never will,
  // so the shell has to stop saying "Loading…" itself.
  reportBootFailure();
});
